import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

export const campSwReorder: FaireAdCampaignEntity = {
  token: "camp_sw_reorder",
  type: "adCampaign",
  advertiserProfileToken: "adv_strange_water",
  segment: "REORDER_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 1000,
  startedRunningAt: "2026-05-15",
  segmentMetrics: {
    numReorderConversions: 14,
    salesDollars: 2389,
    totalAdsSpendDollars: 169,
    returnOnAdSpend: 14.14,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-29T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
